<div class="public-wrap">
  <div class="container">
    <div class="public-wrap-inner">
      <h3 class="register">
        <img src="/assets/images/auction-success-icon.svg" />
        <span>Registration Successful!</span>
      </h3>
      <p class="register-des">
        Thank you for registering for the auction. - {{ auctionTitle }}
      </p>
      <p class="register-des2">
        Our staff will be reviewing your registration request <br /><br />
        This process can take upto 24 hours from the time you registered. We may
        contact you to verify your information and ask for a deposit before
        approving your registration<br /><br />
        If you have any questions, you can contact us at
        service@thebranfordgroup.com or call us at 203-488-7020.
      </p>
      <h3 class="note1">
        Please take a moment to fill out this survey form for us
      </h3>
      <h3 class="note2">May we ask how you heard about the auction ?</h3>

      <div class="check-round-outer">
        <div
          class="custom-checks-square check-round"
          *ngFor="let item of listing"
        >
          <input
            type="checkbox"
            (change)="onChange(item.value, $event.target.checked)"
            id="{{ 'option' + item.value }}"
          />
          <label for="{{ 'option' + item.value }}" class="m-0">
            {{ item.text }}
          </label>
        </div>
      </div>

      <div class="btns-wrap">
        <button
          type="button"
          class="btn btn-colored mr-2"
          [disabled]="surveyOptions.length === 0"
          role="button"
          (click)="onSubmit()"
        >
          Submit Survey
        </button>
        <button
          type="button"
          class="btn btn-white-border"
          role="button"
          (click)="goToBack()"
        >
          No, Thanks
        </button>
      </div>
    </div>
  </div>
</div>
